import { useState, useCallback } from 'react';
import { CallBackProps, STATUS } from 'react-joyride';
import { PROJECT_TOUR_STEPS } from './projectTourSteps';
import { CMS_TOUR_STORAGE_KEYS } from './constants';

export function useCmsProjectTour(isFullyLoaded: boolean, totalSceneOrigins: number) {
  const [run, setRun] = useState(false);
  const completed =
    typeof window !== 'undefined' &&
    localStorage.getItem(CMS_TOUR_STORAGE_KEYS.PROJECT);

  // Auto-start check, re-run on mount and when any input changes
  const [gate, setGate] = useState<{
    isFullyLoaded: boolean;
    completed: string | false | null;
    totalSceneOrigins: number;
  } | null>(null);
  if (
    gate === null ||
    gate.isFullyLoaded !== isFullyLoaded ||
    gate.completed !== completed ||
    gate.totalSceneOrigins !== totalSceneOrigins
  ) {
    setGate({ isFullyLoaded, completed, totalSceneOrigins });
    if (isFullyLoaded && !completed && totalSceneOrigins <= 1) setRun(true);
  }

  const handleJoyrideCallback = useCallback((data: CallBackProps) => {
    if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
      localStorage.setItem(CMS_TOUR_STORAGE_KEYS.PROJECT, 'true');
      setRun(false);
    }
  }, []);

  return { run, steps: PROJECT_TOUR_STEPS, handleJoyrideCallback };
}
